import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import RenderPasswordFormGroup from '../Form/RenderPasswordFormGroup'
import RenderInputFormGroup from "../Form/RenderInputFormGroup"
import {required} from "../Form/rules"
import {Link} from 'react-router-dom'
import {routesUrls} from '../../../settings/routes'
import {handleLoginRequest, successProfileResponse} from '../../../modules/profile'
import {translationsLocaleSelector} from '../../../modules/app'


class Login extends Component{
    render() {
        let {handleSubmit, error, submitting} = this.props
        let {formatMessage} = this.context

        return (
            <div className="auth-form-wrapper">
                <h1 className="h2 text-center">{formatMessage('Login')}</h1>
                <p className="text-center">{formatMessage('Please fill out the following fields to login:')}</p>
                <form className="profile-form" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "username"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("User name")}:`}
                                id = "username"
                                validate = {[required]}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "password"
                                type = "password"
                                component = {RenderPasswordFormGroup}
                                label = {`${formatMessage("Password")}:`}
                                id = "password"
                                validate = {[required]}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <p className="help-block text-center">{formatMessage('If you forgot your password you can')} <Link to={routesUrls.showReset}>{formatMessage('reset it')}</Link>.</p>
                    </div>

                    {
                        error &&
                        <div className="row has-error">
                            <p className="help-block text-center text-danger">{formatMessage(error)}</p>
                        </div>
                    }

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <button className="btn btn-primary btn-block" type="submit" disabled={submitting}>{formatMessage("Login")}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    static contextTypes = {formatMessage: PropTypes.any}
}


export default connect(
    state => ({
        locale : translationsLocaleSelector(state),
    }),
    null,
    null,
    {pure: false}
)(reduxForm({
    form: 'login',
    onSubmit : (values, dispatch) => {
        let {username, password} = values
        return handleLoginRequest({username, password, rememberMe : true})
                .then(successProfileResponse({dispatch, toMainPage:true, isReduxForm : true}))
    },
    pure : false
})(Login))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Auth/Login.js